import React, { useContext } from 'react';
import { navigate } from '@reach/router';

import { makeStyles } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Container from '@material-ui/core/Container';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import Typography from '@material-ui/core/Typography';

import AuthContext from '../../services/firebase/AuthContext';
import Copyright from '../Copyright';
import { SelectFirmPagePath } from '../solicitors/SelectFirmPage';
import { SelectOrganizationPagePath } from '../organizations/SelectOrganizationPage';

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(3),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}));

const SignUpCompletePage = () => {
    const { logout } = useContext(AuthContext);
    const classes = useStyles();

    const handleSignOut = () => {
        logout().then(() => navigate("/"));
    }

    return (
        <Container component="main" maxWidth="xs">
            <CssBaseline />
            <div className={classes.paper}>
                <Typography component="h1" variant="h6">The Intermediary Cooperative</Typography>
                <Avatar className={classes.avatar}>
                    <PersonAddIcon />
                </Avatar>
                <Typography component="h1" variant="h5">
                    Complete Sign Up
          </Typography>
                <div className={classes.form}>
                    <Grid container spacing={1} >
                        <Grid item>
                            <Typography variant="h6" color="initial">What type of organisation do you work for?</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Button fullWidth variant="contained" color="primary" onClick={() => navigate(SelectFirmPagePath)}>Law Firm / Solicitor</Button>
                        </Grid>
                        {/* <Grid item xs={12}>
                            <Button fullWidth variant="contained" color="primary" onClick={() => navigate('/signup/courts')}>Court</Button>
                        </Grid> */}
                        <Grid item xs={12}>
                            <Button fullWidth variant="contained" color="primary" onClick={() => navigate(SelectOrganizationPagePath)}>Other</Button>
                        </Grid>
                    </Grid>
                </div>
            </div>
            <Box mt={5}>
                <Copyright />
            </Box>
            <Box>
                <Button onClick={handleSignOut} variant="outlined" fullWidth style={{ marginTop: '1rem'}}>Sign Out</Button>
            </Box>
        </Container>
    );

}

const SignUpCompletePagePath = '/signup/complete';

export {
    SignUpCompletePagePath
}

export default SignUpCompletePage;